import * as styledComponents from "styled-components";
const { default: styled, css } = styledComponents;

export { css };
export default styled;
